// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    ICartItem,
    ICreateCheckoutPaymentIntentResult,
}                               from '../interfaces';

const stripeCreatePaymentIntentWithCheckoutSession = async ({
    test,
    cartItems,
    userEmail,
    customerId,
    promotionIds,
}: {
    test: boolean,
    cartItems: ICartItem[],
    userEmail?: string,
    customerId?: string,
    promotionIds?: string[],
}): Promise<ICreateCheckoutPaymentIntentResult> => {
    const functions = getFunctions();
    const createPaymentIntentWithCheckoutSession = httpsCallable<
        Record<string, boolean | string | string[] | ICartItem[]>,
        ICreateCheckoutPaymentIntentResult
    >(
        functions,
        'stripeCreatePaymentIntentWithCheckoutSession',
    );

    const args: Record<string, boolean | string | string[] | ICartItem[]> = {
        test,
        cartItems,
    };
    if (userEmail) args.userEmail = userEmail;
    if (customerId) args.customerId = customerId;
    if (promotionIds && promotionIds.length > 0) args.promotionIds = [...promotionIds];

    return createPaymentIntentWithCheckoutSession(args).then((result) => {
        const response = result.data as ICreateCheckoutPaymentIntentResult;
        return response;
    }).catch((err) => {
        throw err;
    });
};

export default stripeCreatePaymentIntentWithCheckoutSession;
